module.exports = __webpack_public_path__ + "img/mysql.aa7dd537.png";